import React, { useCallback, useMemo } from 'react';
import tinycolor from 'tinycolor2';
import styles from './Tag.module.scss';

function Tag(props) {
    const { className = '', tag, onClick } = props,
        borderColor = useMemo(() => (tag.color ? tinycolor(tag.color).darken().toString() : null), [tag.color]);

    const handleClick = useCallback(() => {
        if (onClick) {
            onClick(tag);
        }
    }, [tag, onClick]);

    return (
        <div className={[className, onClick ? styles.clickable : ''].join(' ')} onClick={handleClick} style={{ backgroundColor: tag.color, borderColor }}>
            {tag.label ?? tag.name}
        </div>
    );
}

export default Tag;
